"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitManualDistribution = void 0;
const ApiClient_1 = require("../ApiClient");
const submitManualDistribution = (form) => ApiClient_1.apiClient.post('/api/manual-distributions', form);
exports.submitManualDistribution = submitManualDistribution;
